import Store from 'store'

/**
 * @description 所有业务判断工具方法的定义
 */

export const isPingAn = (): boolean => {
  const { enterpriseId = '' } = Store.get('sessionInfo') || {}
  return enterpriseId === '0EA3756D964D21C3E054A0369F1934EC'
}

export const isTest = () => {
  const url = window.location.href
  return (
    url.includes('localhost') || url.includes('stg1') || url.includes('stg5')
  )
}

export const isOuterLink = (
  ext: { source?: string; [key: string]: any } = {}
) => ext && ext.source === '外部'

export default {
  isPingAn,
  isTest,
  isOuterLink,
}
